import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
// import "./PaymentFrequencyDropdown.css";

const options = [
  { value: "quarterly", label: "quarterly", discountPercent: null },
  { value: "biannually", label: "biannually", discountPercent: "15" },
  { value: "yearly", label: "annually", discountPercent: "20" },
];

const PaymentFrequencyDropdown = ({handleClick}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(options[2]);
  const dropdownRef = useRef();

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    handleClick(option.value)
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <label className="dropdown-label">{t("planPurchase.paymentFrequency")}</label>
      <div className={`dropdown ${isOpen ? "open" : ""}`} onClick={toggleDropdown}>
        <div className="dropdown-selected">
          {t(`common.${selected.label}`)}
          {selected.discountPercent && (
            <span className="dropdown-discount"> - {t("planPurchase.percentDiscount", { quantity: selected.discountPercent})}</span>
          )}
        </div>
        <span className="dropdown-arrow">▼</span>
      </div>
      {isOpen && (
        <ul className="dropdown-options">
          {options.map((option) => (
            <li
              key={option.value}
              className={`dropdown-option ${
                option.value === selected.value ? "selected" : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {t(`common.${option.label}`)}
              {option.discountPercent && (
                <span className="dropdown-discount"> - {t("planPurchase.percentDiscount", { quantity: option.discountPercent})}</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PaymentFrequencyDropdown;
